import { Box, BoxProps } from "@mui/material";

import { styled } from "@mui/material/styles";
import { Theme } from "@mui/material/styles";

import createStyles from "@mui/styles/createStyles";
import makeStyles from "@mui/styles/makeStyles";

import { MeasurementType, RAGStatus } from "../shared/enums/Result";

import { CablePDIcon } from "./CablePD";
import { TevIcon } from "./Tev";
import { UhfIcon } from "./Uhf";
import { UltrasonicIcon } from "./Ultrasonic";
import { VpisIcon } from "./Vpis";

interface Props {
  measurementType: MeasurementType;
  ragStatus?: RAGStatus;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    red: {
      color: theme.palette.redStatus.main,
    },
    amber: {
      color: theme.palette.amberStatus.main,
    },
    green: {
      color: theme.palette.greenStatus.main,
    },
    default: {
      color: theme.palette.primary.main,
    },
  }),
);

export const IconContainer = styled(Box)<BoxProps>(({ height, width }) => ({
  display: "flex",
  justifyContent: "center",
}));

const defaultSize = "1em";

export function MeasurementIcon(props: Props & BoxProps) {
  const classes = useStyles();
  const { measurementType, ragStatus, ...rest } = props;

  let colorClass = classes.default;

  if (ragStatus === RAGStatus.Red) colorClass = classes.red;
  else if (ragStatus === RAGStatus.Amber) colorClass = classes.amber;
  else if (ragStatus === RAGStatus.Green) colorClass = classes.green;

  switch (props.measurementType) {
    case MeasurementType.CablePD:
      return (
        <IconContainer height={props.height || defaultSize} width={props.width || defaultSize} {...rest}>
          <CablePDIcon className={colorClass} />
        </IconContainer>
      );

    case MeasurementType.TEV:
      return (
        <IconContainer height={props.height || defaultSize} width={props.width || defaultSize} {...rest}>
          <TevIcon className={colorClass} />
        </IconContainer>
      );

    case MeasurementType.UHF:
      return (
        <IconContainer height={props.height || defaultSize} width={props.width || defaultSize} {...rest}>
          <UhfIcon className={colorClass} />
        </IconContainer>
      );

    case MeasurementType.Ultra:
      return (
        <IconContainer height={props.height || defaultSize} width={props.width || defaultSize} {...rest}>
          <UltrasonicIcon className={colorClass} />
        </IconContainer>
      );

    case MeasurementType.VPIS:
      return (
        <IconContainer height={props.height || defaultSize} width={props.width || defaultSize} {...rest}>
          <VpisIcon className={colorClass} />
        </IconContainer>
      );

    default:
      return null;
  }
}
